<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import { todoComputed, todoMethods } from '@/state/helpers'
import { mapGetters } from 'vuex'

/**
 * Starter component
 */
export default {
  page: {
    title: 'Route',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {}
  },

  computed: {
    ...todoComputed,
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
      hasAccessAll: 'identity/hasAccessAll',
    }),
    /**
     * Total no. of records
     */

    title() {
      return this.$t('menuitems.route.title')
    },
  },

  methods: {
    ...todoMethods,
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" />
    <div class="card mc-card mc-card-front">
      <div class="card-body">
        <b-tabs content-class="p-3 text-muted">
          <b-row class="mc-card__list">
            <b-col md="6">
              <b-button
                variant="outline-light"
                @click="$router.push({ name: 'Route Planning' })"
                class="d-block w-100 mc-card__list-item clearfix"
              >
                <i class="mc-fa icon-outline_scheduler"> </i>
                <div class="mc-card__list-item-content">
                  <h4>{{ this.$t('route.routePlaning.title') }}</h4>
                  <p>{{ this.$t('route.routePlaning.text') }}</p>
                </div>
              </b-button>
            </b-col>
            <b-col md="6">
              <b-button
                variant="outline-light"
                @click="$router.push({ name: 'Route Monitoring' })"
                class="d-block w-100 mc-card__list-item clearfix"
              >
                <i class="mc-fa icon-outline_pin-history"> </i>
                <div class="mc-card__list-item-content">
                  <h4>{{ this.$t('route.routeMonitoring.title') }}</h4>
                  <p>{{ this.$t('route.routeMonitoring.title') }}</p>
                </div>
              </b-button>
            </b-col>
          </b-row>
        </b-tabs>
      </div>
    </div>
  </Layout>
</template>
